import { render, staticRenderFns } from "./PageInvoiceCustomer.vue?vue&type=template&id=3163d741&scoped=true"
import script from "./PageInvoiceCustomer.vue?vue&type=script&lang=js"
export * from "./PageInvoiceCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163d741",
  null
  
)

export default component.exports